import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199da6ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editClub" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Vis/ Rediger kluboplysninger", -1))
const _hoisted_3 = { class: "clubContainer" }
const _hoisted_4 = { class: "layout gutter--lg clubInfoContainer" }
const _hoisted_5 = { class: "row justify--space-around align--center" }
const _hoisted_6 = { class: "flex md8 xs12" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Klubnavn: ")
const _hoisted_9 = { class: "flex md4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Sæt/ rediger klublogo")
const _hoisted_11 = { class: "row justify--space-around align--center" }
const _hoisted_12 = { class: "flex md3 xs8" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Etableret: ")
const _hoisted_15 = { class: "flex md2 xs4" }
const _hoisted_16 = { class: "info" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Region: ")
const _hoisted_18 = { class: "flex md3 xs6" }
const _hoisted_19 = { class: "info" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Saldo: ")
const _hoisted_21 = { class: "flex md4 xs12" }
const _hoisted_22 = { class: "info" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Kontingent udløber: ")
const _hoisted_24 = { class: "row justify--space-around align--center" }
const _hoisted_25 = { class: "flex md6 xs12" }
const _hoisted_26 = { class: "info" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Vej og husnr.: ")
const _hoisted_28 = { class: "flex md3 xs6" }
const _hoisted_29 = { class: "info" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Postnr.: ")
const _hoisted_31 = { class: "flex md3 xs6" }
const _hoisted_32 = { class: "info" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("By: ")
const _hoisted_34 = { class: "row justify--space-around align--center" }
const _hoisted_35 = { class: "flex md6 xs12" }
const _hoisted_36 = { class: "info" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Telefon: ")
const _hoisted_38 = { class: "flex md6 xs12" }
const _hoisted_39 = { class: "info" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Email: ")
const _hoisted_41 = { class: "row justify--space-around align--center" }
const _hoisted_42 = { class: "flex md6 xs12" }
const _hoisted_43 = { class: "info" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Hjemmeside: ")
const _hoisted_45 = { class: "flex md6 xs12" }
const _hoisted_46 = { class: "info" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Facebook: ")
const _hoisted_48 = { class: "row justify--space-around align--center" }
const _hoisted_49 = { class: "flex md4 xs6" }
const _hoisted_50 = { class: "info" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Antal baner: ")
const _hoisted_52 = { class: "flex md4 xs6" }
const _hoisted_53 = { class: "info" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Hjemmekampe: ")
const _hoisted_55 = { class: "flex md4" }
const _hoisted_56 = { class: "info" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Kørestolsvenlig: ")
const _hoisted_58 = { class: "row justify--space-around align--center" }
const _hoisted_59 = { class: "flex md4" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Ændre klubansvarlig")
const _hoisted_61 = { class: "flex md4" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Rediger kluboplysninger")
const _hoisted_63 = { class: "layout gutter--lg clubInfoContainer mt-4" }
const _hoisted_64 = { class: "row justify--space-around" }
const _hoisted_65 = {
  class: "flex md6 align-self--start",
  id: "clubDescription"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info center" }, "Klubbeskrivelse", -1))
const _hoisted_67 = { class: "row justify--center" }
const _hoisted_68 = { class: "flex" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_70 = { class: "flex md6 align-self--start" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info center" }, "Åbningstider", -1))
const _hoisted_72 = { class: "flex md3 xs3" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "flex md3 xs3" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "flex md5 xs5" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "flex md1 xs1" }
const _hoisted_80 = { class: "row justify--center" }
const _hoisted_81 = { class: "flex" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode("Tilføj åbningstider")
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Rediger åbningstider", -1))
const _hoisted_84 = { class: "layout gutter--lg" }
const _hoisted_85 = { class: "row justify--space-around align--center" }
const _hoisted_86 = { class: "md4 flex" }
const _hoisted_87 = { class: "md4 flex" }
const _hoisted_88 = { class: "md4 flex" }
const _hoisted_89 = { class: "row justify--space-around align--center" }
const _hoisted_90 = { class: "flex md12" }
const _hoisted_91 = { class: "row justify--center" }
const _hoisted_92 = { class: "flex" }
const _hoisted_93 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_94 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Tilføj åbningstid", -1))
const _hoisted_96 = { class: "layout gutter--lg" }
const _hoisted_97 = { class: "row justify--space-around align--center" }
const _hoisted_98 = { class: "md4 flex" }
const _hoisted_99 = { class: "md4 flex" }
const _hoisted_100 = { class: "md4 flex" }
const _hoisted_101 = { class: "row justify--space-around align--center" }
const _hoisted_102 = { class: "flex md12" }
const _hoisted_103 = { class: "row justify--center" }
const _hoisted_104 = { class: "flex" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Rediger klubinformation", -1))
const _hoisted_108 = { class: "layout gutter--lg" }
const _hoisted_109 = { class: "row justify--space-around align--center" }
const _hoisted_110 = { class: "flex md6" }
const _hoisted_111 = { class: "flex md3" }
const _hoisted_112 = { class: "flex md3" }
const _hoisted_113 = { class: "row justify--space-around align--center" }
const _hoisted_114 = { class: "flex md6" }
const _hoisted_115 = { class: "flex md6" }
const _hoisted_116 = { class: "row justify--space-around align--center" }
const _hoisted_117 = { class: "flex md6" }
const _hoisted_118 = { class: "flex md6" }
const _hoisted_119 = { class: "row justify--space-around align--center" }
const _hoisted_120 = { class: "md4 flex" }
const _hoisted_121 = { class: "md4 flex" }
const _hoisted_122 = { class: "md4 flex" }
const _hoisted_123 = { class: "row justify--center" }
const _hoisted_124 = { class: "flex" }
const _hoisted_125 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_126 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Nuværende logo", -1))
const _hoisted_128 = { class: "layout gutter--lg" }
const _hoisted_129 = { class: "row justify--center" }
const _hoisted_130 = { class: "flex" }
const _hoisted_131 = { class: "row justify--center" }
const _hoisted_132 = { class: "row justify--center" }
const _hoisted_133 = { class: "flex" }
const _hoisted_134 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Ændre klubansvarlig", -1))
const _hoisted_136 = { class: "layout gutter--md" }
const _hoisted_137 = { class: "row justify--center align--center" }
const _hoisted_138 = { class: "flex" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center align--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "info center" }, "Advarsel, der kan kun være en klubansvarlig. Så hvis du ændre den klubansvarlige, mister du retten til at lave flere ændringer her")
  ])
], -1))
const _hoisted_140 = { class: "row justify--center align--center" }
const _hoisted_141 = { class: "flex" }
const _hoisted_142 = { class: "row justify--center align--center" }
const _hoisted_143 = { class: "flex" }
const _hoisted_144 = { class: "row justify--center" }
const _hoisted_145 = { class: "flex" }
const _hoisted_146 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_147 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_file_upload = _resolveComponent("va-file-upload")!
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_divider = _resolveComponent("va-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editClubLogoModal = true))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("i", null, _toDisplayString(_ctx.toDanishDateString(_ctx.clubData.clubEstablishedDate )), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubRegion.slice(7).trim()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubFunds), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate(_ctx.clubData.clubLicenseExpires)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("p", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubAddress), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("p", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubPostalNumber), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubCity), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("p", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubTelephone), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("p", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubEmail), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("p", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("strong", null, _toDisplayString((_ctx.clubData.clubWebpage === '' ? 'Ingen' : _ctx.clubData.clubWebpage)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("p", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("strong", null, _toDisplayString((_ctx.clubData.clubFacebook === '' ? 'Ingen' : _ctx.clubData.clubFacebook)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("p", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.clubLanes), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("p", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("strong", null, _toDisplayString(_ctx.clubData.homeMatches), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("p", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("strong", null, _toDisplayString((_ctx.clubData.wheelchairFriendly ? 'Ja' : 'Nej')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_va_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeClubManager = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  name: "edit",
                  class: "mr-2"
                }),
                _hoisted_60
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_va_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editClubModal = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  name: "edit",
                  class: "mr-2"
                }),
                _hoisted_62
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createVNode(_component_QuillEditor, {
              ref: "clubDescription",
              options: _ctx.quillToolbar,
              contentType: "html",
              content: _ctx.clubData.clubDescription,
              "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clubData.clubDescription) = $event)),
              theme: "snow",
              class: "quillEditor"
            }, null, 8, ["options", "content"]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createVNode(_component_va_button, {
                  color: "success",
                  disabled: _ctx.clubData.clubDescription === _ctx.clubData.originalClubDescription,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateDescription()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_69
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clubData.openingHours, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row align--center",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("button", {
                    class: "openingHoursBtn",
                    onClick: ($event: any) => (_ctx.editOpeningHours(item.id))
                  }, _toDisplayString(_ctx.convertOe(item.aabningstider_dag)), 9, _hoisted_73)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("button", {
                    class: "openingHoursBtn",
                    onClick: ($event: any) => (_ctx.editOpeningHours(item.id))
                  }, _toDisplayString(item.aabningstider_aaben.slice(0, 5) + ' - ' + item.aabningstider_luk.slice(0, 5)), 9, _hoisted_75)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  (item.aabningstider_kommentar === null || item.aabningstider_kommentar === '')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "openingHoursBtn",
                        onClick: ($event: any) => (_ctx.editOpeningHours(item.id))
                      }, "Tilføj kommentar", 8, _hoisted_77))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "openingHoursBtn",
                        onClick: ($event: any) => (_ctx.editOpeningHours(item.id))
                      }, _toDisplayString((item.aabningstider_kommentar === null ? '' : item.aabningstider_kommentar)), 9, _hoisted_78))
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_va_icon, {
                    name: "delete_forever",
                    class: "hoverEffect",
                    onClick: ($event: any) => (_ctx.deleteOpeningHours(item.id)),
                    color: "danger"
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_va_button, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createOpeningHoursModal = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      name: "edit",
                      class: "mr-2"
                    }),
                    _hoisted_82
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.editOpeningHoursModal,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editOpeningHoursModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_83
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createVNode(_component_va_select, {
                modelValue: _ctx.openingHoursData.day,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openingHoursData.day) = $event)),
                options: _ctx.editOpeningHoursDayOptions,
                label: "Dag",
                bordered: ""
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.openingHoursData.from,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.openingHoursData.from) = $event)),
                type: "time",
                label: "Fra",
                bordered: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.openingHoursData.to,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.openingHoursData.to) = $event)),
                type: "time",
                label: "Til",
                bordered: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.openingHoursData.comment,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.openingHoursData.comment) = $event)),
                type: "text",
                label: "Evt. kommentar",
                bordered: ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateOpeningHours())),
              color: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_93
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editOpeningHoursModal = false)),
              color: "secondary"
            }, {
              default: _withCtx(() => [
                _hoisted_94
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.createOpeningHoursModal,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.createOpeningHoursModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_95
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createVNode(_component_va_select, {
                modelValue: _ctx.openingHoursData.day,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.openingHoursData.day) = $event)),
                options: _ctx.editOpeningHoursDayOptions,
                label: "Dag",
                bordered: ""
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.openingHoursData.from,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.openingHoursData.from) = $event)),
                type: "time",
                label: "Fra",
                bordered: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.openingHoursData.to,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.openingHoursData.to) = $event)),
                type: "time",
                label: "Til",
                bordered: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              _createVNode(_component_va_input, {
                modelValue: _ctx.openingHoursData.comment,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.openingHoursData.comment) = $event)),
                type: "text",
                label: "Evt. kommentar",
                bordered: ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createOpeningHours())),
              color: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_105
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.createOpeningHoursModal = false)),
              color: "secondary"
            }, {
              default: _withCtx(() => [
                _hoisted_106
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.editClubModal,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.editClubModal) = $event)),
      width: "50%",
      "closable-mask": false
    }, {
      header: _withCtx(() => [
        _hoisted_107
      ]),
      body: _withCtx(() => [
        _createVNode(_component_va_form, { ref: "form" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.clubData.clubAddress,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.clubData.clubAddress) = $event)),
                    bordered: "",
                    label: "Vej og husnr.",
                    rules: [(v) => v.length > 1 || 'Angiv en adresse' ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createVNode(_component_va_input, {
                    type: "number",
                    modelValue: _ctx.clubData.clubPostalNumber,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.clubData.clubPostalNumber) = $event)),
                    label: "Postnr.",
                    bordered: "",
                    rules: [(v) => v.length === 4 || 'Postnr. mangler']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_112, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.clubData.clubCity,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.clubData.clubCity) = $event)),
                    label: "By",
                    readonly: "",
                    bordered: "",
                    rules: [(v) => v.length > 1 || 'By mangler']
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("div", _hoisted_114, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.clubData.clubTelephone,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.clubData.clubTelephone) = $event)),
                    label: "Telefon",
                    bordered: "",
                    rules: [(v) => (v.length === 8 || !isNaN(Number(v))) || 'Vi skal bruge et telefonnummer' ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_115, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.clubData.clubEmail,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.clubData.clubEmail) = $event)),
                    label: "Email",
                    bordered: "",
                    rules: [(v) => _ctx.checkEmail(v) || 'Angiv venligst en korrekt email adresse' ]
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  _createVNode(_component_va_input, {
                    type: "url",
                    modelValue: _ctx.clubData.clubWebpage,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.clubData.clubWebpage) = $event)),
                    label: "Hjemmeside",
                    bordered: "",
                    rules: [(v) => (v === '' || _ctx.testValidWebpage(v)) || 'Indtast en gyldig hjemmeside']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_118, [
                  _createVNode(_component_va_input, {
                    type: "url",
                    modelValue: _ctx.clubData.clubFacebook,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.clubData.clubFacebook) = $event)),
                    label: "Facebook",
                    bordered: "",
                    rules: [(v) => (v === '' || _ctx.testValidFacebook(v)) || 'Indtast en gyldig Facebook adresse']
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _createVNode(_component_va_input, {
                    class: "center",
                    type: "number",
                    modelValue: _ctx.clubData.clubLanes,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.clubData.clubLanes) = $event)),
                    label: "Antal baner",
                    bordered: "",
                    rules: [(v) => Number(v) >= 0 || 'Angiv et gyldigt antal baner']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createVNode(_component_va_input, {
                    class: "center",
                    type: "number",
                    modelValue: _ctx.clubData.homeMatches,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.clubData.homeMatches) = $event)),
                    label: "Hjemmekampe",
                    bordered: "",
                    rules: [(v) => Number(v) >= 0 || 'Angiv et gyldigt antal hjemmekampe']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_122, [
                  _createVNode(_component_va_checkbox, {
                    modelValue: _ctx.clubData.wheelchairFriendly,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.clubData.wheelchairFriendly) = $event)),
                    label: "Kørestolsvenlig"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[30] || (_cache[30] = ($event: any) => {_ctx.$refs.form.validate();_ctx.updateClubInfo()})
            }, {
              default: _withCtx(() => [
                _hoisted_125
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.editClubModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_126
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.editClubLogoModal,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.editClubLogoModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_127
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("div", _hoisted_130, [
              _createVNode(_component_va_file_upload, {
                "file-types": ".jpg,.jpeg,.png",
                dropzone: "",
                type: "single",
                modelValue: _ctx.uploadLogo,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.uploadLogo) = $event)),
                "hide-file-list": true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_131, [
            _createVNode(_component_va_image, {
              class: "flex lg10",
              src: _ctx.extractLogoURLFromClubLogoData(this.clubData.clubLogo)
            }, null, 8, ["src"])
          ]),
          _createVNode(_component_va_divider)
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createVNode(_component_va_button, {
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.editClubLogoModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_134
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.changeClubManager,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.changeClubManager) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_135
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_136, [
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createVNode(_component_va_icon, {
                class: "mr-2",
                name: "warning",
                color: "warning"
              }),
              _createVNode(_component_va_icon, {
                class: "ml-2",
                name: "warning",
                color: "warning"
              })
            ])
          ]),
          _hoisted_139,
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("div", _hoisted_141, [
              _createVNode(_component_va_icon, {
                class: "mr-2",
                name: "warning",
                color: "warning"
              }),
              _createVNode(_component_va_icon, {
                class: "ml-2",
                name: "warning",
                color: "warning"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _createVNode(_component_va_select, {
                label: "Klubansvarlig",
                modelValue: _ctx.clubManageValue,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.clubManageValue) = $event)),
                options: _ctx.clubManagerOptions,
                searchable: "",
                "text-by": (v) => v.name,
                "track-by": (v) => v.id
              }, null, 8, ["modelValue", "options", "text-by", "track-by"])
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_144, [
          _createElementVNode("div", _hoisted_145, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.updateClubManager()))
            }, {
              default: _withCtx(() => [
                _hoisted_146
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.changeClubManager = false))
            }, {
              default: _withCtx(() => [
                _hoisted_147
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}